module.exports = __webpack_public_path__ + "img/medical_medicine_analgesic1.295d34ad.jpg";